import React, { Component } from "react";

class ReporteFormato3 extends Component {
  render() {
    return (
      <div>
        <fieldset className="col-md-12">
          <legend>IMPORTACIONES</legend>

          <div className="table-responsive">
            <table className="table table-striped m-b-0 table-hover">
              <colgroup>
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
                <col style={{ width: "7.692%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Nombre Genérico</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Producto</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Presentación</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Ingreso Importado</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Ingreso Importado</b>
                  </th>

                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Devolución Importado</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Devolución Importado</b>
                  </th>

                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Deterioro Importado</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Deterioro Importado</b>
                  </th>

                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Ventas Importado</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Ventas Importado</b>
                  </th>

                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Existencia Actual</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Existencia Actual</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props.state.option_productos.map((producto, index) => (
                  <tr key={index}>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.nombre_generico}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.producto_concat}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.presentacion}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_importado}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_importado ? (
                        producto.gramos_importado
                      ) : (
                        <div className="form-group">
                          <input
                            type="text"
                            maxLength="15"
                            autoComplete="off"
                            className="form-control"
                            value={producto.gramos_importado || ""}
                            id={`gramos_importado-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_importado-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>

                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_devolucion}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      <div className="form-group">
                        {!producto.pedir_gramos_devolucion ? (
                          producto.gramos_devolucion
                        ) : (
                          <input
                            maxLength="15"
                            autoComplete="off"
                            type="text"
                            className="form-control"
                            value={producto.gramos_devolucion || ""}
                            id={`gramos_devolucion-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                        )}
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id={`gramos_devolucion-${index}-error`}
                        ></div>
                      </div>
                    </td>

                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_deterioro}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_deterioro ? (
                        producto.gramos_deterioro
                      ) : (
                        <div className="form-group">
                          <input
                            maxLength="15"
                            autoComplete="off"
                            type="text"
                            className="form-control"
                            value={producto.gramos_deterioro || ""}
                            id={`gramos_deterioro-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_deterioro-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>

                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_ventas}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_ventas ? (
                        producto.gramos_ventas
                      ) : (
                        <div
                          className="form-group"
                          onChange={this.props.handleCantidadGramosChange}
                        >
                          <input
                            type="text"
                            maxLength="15"
                            autoComplete="off"
                            className="form-control"
                            value={producto.gramos_ventas || ""}
                            id={`gramos_ventas-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_ventas-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>

                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_existencia_actual}
                    </td>

                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_existencia_actual ? (
                        producto.gramos_existencia_actual
                      ) : (
                        <div
                          className="form-group"
                          onChange={this.props.handleCantidadGramosChange}
                        >
                          <input
                            type="text"
                            maxLength="15"
                            autoComplete="off"
                            className="form-control"
                            value={producto.gramos_existencia_actual || ""}
                            id={`gramos_existencia_actual-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_existencia_actual-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </fieldset>
      </div>
    );
  }
}

export default ReporteFormato3;
